import { render, staticRenderFns } from "./DSTextElement.vue?vue&type=template&id=79198f3a&scoped=true&"
import script from "./DSTextElement.vue?vue&type=script&lang=ts&"
export * from "./DSTextElement.vue?vue&type=script&lang=ts&"
import style0 from "./DSTextElement.vue?vue&type=style&index=0&id=79198f3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79198f3a",
  null
  
)

export default component.exports